<template>
    <div class="project-outlier-detection-container container-fluid mt-4 mb-4">
        <div class="row mt-2">
            <div class="col mx-auto">
                <h4>We analyzed <b>{{ project.num_of_rows }}</b> records, and found <b>{{ outliersNum }}</b>
                    outliers.<br>
                </h4>
                <span v-if="outliersNum">
                        <h4>Here are the outliers we found:</h4>
                </span>
            </div>
        </div>
        <data-table v-if="outliersNum" v-bind:data="filteredOutlierData"
                    v-bind:data-table="true"></data-table>
        <project-results-preview-data v-bind:preview-data="previewData" v-bind:number-of-rows="numberOfRows"></project-results-preview-data>
        <modal-component></modal-component>
    </div>
</template>
<script>

    import {mapActions, mapGetters} from 'vuex';
    import _ from 'lodash';

    export default {
        props: {
            project: Object
        },
        mounted() {
            this.getOutlierDetectionResultsFromAPI();
        },
        data: function () {
            return {
                outliers: [],
                filteredOutlierData: {
                    headers: [],
                    rows: []
                },
                numberOfRows: 0,
                previewData: {
                    headers: [],
                    rows: []
                }
            }
        },
        computed: {
            outliersNum: function () {
                return this.filteredOutlierData.rows.length;
            }
        },
        methods: {
            ...mapActions([
                'closeModal',
                'openModal',
                'setLoading',
                'setMessage',
                'setModalAllowClose',
                'requestRecipeFromAPI',
                'handleError'
            ]),

            getOutlierDetectionResultsFromAPI() {
                let instance = this;
                instance.requestRecipeFromAPI(instance.project)
                    .then(function (response) {
                        console.log(response);
                        const rows = response.data.parsedCSV.rows;
                        instance.numberOfRows = response.data.parsedCSV.numberOfRows;
                        instance.previewData.headers = response.data.parsedCSV.headers;
                        instance.previewData.rows = rows;
                        instance.filterOutlierData(response);
                    })
                    .catch(function (error) {
                        instance.handleError(error)
                    });
            },
            filterOutlierData(response) {
                this.filteredOutlierData.headers = response.data.parsedCSV.headers;

                this.filteredOutlierData.rows = _.filter(response.data.parsedCSV.rows, function (element) {
                    return _.find(response.data.outliers, {row: element.rowIndex});
                });

            }
        }
    }

</script>
<style lang="scss">

    @import "../../sass/variables";

    .preview-data-message {
        color: $blue;
    }

</style>
